module.exports = __webpack_public_path__ + "img/regional-office-alternative-location-analisys-hover.2b4039c0.svg";